const es = {
  common: {
    appName: "VytaliDays", loading: "Cargando…", save: "Guardar", cancel: "Cancelar",
    delete: "Eliminar", edit: "Editar", create: "Crear", close: "Cerrar", confirm: "Confirmar",
    back: "Volver", search: "Buscar", none: "Ninguno", yes: "Sí", no: "No", reason: "Motivo",
    submit: "Enviar", actions: "Acciones", points: "puntos", optional: "opcional",
    language: "Idioma", logout: "Cerrar sesión", saved: "Guardado", required: "Obligatorio",
    share: "Compartir", start: "Inicio", end: "Fin", copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado", sending: "Enviando…",
  },
  auth: {
    signIn: "Iniciar sesión", email: "Correo electrónico", password: "Contraseña",
    tagline: "Plataforma de activación de Embajadores",
    inviteOnly: "Acceso solo por invitación",
    welcome: "Bienvenido de nuevo", acceptTitle: "Activar su cuenta",
    choosePassword: "Elija una contraseña", passwordHint: "8 caracteres mínimo",
    consent: "Acepto que las fotos tomadas durante los VytaliDays sean utilizadas por Vytali en el marco de las activaciones.",
    activate: "Activar mi cuenta", invalidInvite: "Invitación no válida o vencida",
  },
  nav: {
    home: "Inicio", events: "Eventos", checkin: "Registro", field: "Terreno", profile: "Perfil",
    notifications: "Notificaciones", dashboard: "Panel", users: "Usuarios", teams: "Equipos",
    campaigns: "Campañas", partners: "Socios", review: "Revisión", reports: "Informes",
    points: "Puntos", ledger: "Registro de puntos", leads: "Solicitudes de socios",
    system: "Sistema", analytics: "Analítica", myQr: "Mi QR", outbox: "Leads de eventos",
  },
  qr: {
    title: "Mi QR personal",
    lead: "Muestre este código durante un VytaliDay: cada lead captado se le atribuye automáticamente.",
    download: "Descargar", attribution: "Atribución automática",
    autoAttributed: "Evento, socio y campaña atribuidos automáticamente.",
    noActiveEvent: "Sin evento activo. Regístrese para activar la atribución automática; si no, la persona podrá elegir el evento.",
    myLeads: "Mis leads captados", noLeads: "Todavía no hay leads.",
    manualTitle: "Lead manual",
    manualCta: "Añadir un lead manualmente",
    manualHint: "Para una persona sin teléfono inteligente o que no puede escanear el QR. Misma atribución y misma transmisión a VytaliLeads.",
    manualConsent: "La persona consiente en ser contactada por Vytali sobre su solicitud.",
    manualSubmit: "Guardar el lead", manualSaved: "Lead guardado y transmitido",
    offlineNote: "Estás sin conexión: el lead se guardará localmente y se transmitirá cuando vuelva la red.",
    offlineQueued: "Lead guardado — pendiente de sincronización",
    offlinePending: "Pendiente de sincronización", offlineWaiting: "Pendiente de sincronización",
    offlineSyncNow: "Sincronizar ahora", offlineSynced: "{{n}} lead(s) sincronizado(s)",
    offlineNeedsEvent: "Elige el evento para atribuir este lead antes de sincronizar.",
    offlineSyncNoEvent: "Sincronizar sin atribución", offlineError: "Error: {{msg}}",
  },
  capture: {
    eyebrow: "VytaliDays", title: "Mantengámonos en contacto",
    withAmbassador: "Con {{name}}",
    firstName: "Nombre", lastName: "Apellido", phone: "Teléfono", email: "Correo electrónico",
    business: "Comercio / empresa (opcional)", interest: "Lo que le interesa",
    notes: "Notas (opcional)", chooseEvent: "Evento", noEvent: "Ningún evento",
    consent: "Acepto que Vytali me contacte sobre mi solicitud.",
    submit: "Enviar mis datos",
    nameRequired: "El nombre es obligatorio",
    contactRequired: "Se requiere un correo o un teléfono",
    consentRequired: "Se requiere su consentimiento",
    thanksTitle: "¡Gracias!", thanksText: "Sus datos han sido enviados. Un miembro del equipo Vytali le contactará pronto.",
    invalid: "Este código QR no es válido.",
    privacy: "Sus datos se utilizan únicamente para este seguimiento.",
  },
  outbox: {
    title: "Leads de eventos", lead: "Cola de transmisión de los leads captados hacia VytaliLeads.",
    flush: "Transmitir ahora", export: "Exportar CSV (respaldo)", retry: "Reintentar",
    retried: "Reintento en cola", flushed: "{{n}} entrega(s) procesada(s)",
    notConfigured: "Integración VytaliLeads no configurada",
    notConfiguredHint: "La API de VytaliLeads aún no está conectada: los leads permanecen en cola y se transmitirán en cuanto se configuren la URL y la clave.",
    contact: "Contacto", attribution: "Atribución", delivery: "Entrega",
    environment: "Entorno",
    blocked: "Transmisión bloqueada por la configuración: {{reason}}",
    externalId: "ID VytaliLeads", attempts: "Intentos",
    attemptsTotal: "Intentos (auto + manuales)", manual: "manuales",
    status: { pending: "Pendiente", sent: "Enviado", confirmed: "Confirmado",
              failed: "Fallido", retry: "Reintentar" },
  },
  fieldLeads: {
    title: "Leads del terreno", export: "Exportar los leads", total: "Total",
    qr: "QR autoservicio", manual: "Manuales", offline: "Sin conexión sincronizados",
    pending: "Pendientes de sincronización", confirmed: "Confirmados en VytaliLeads",
    exported: "Exportación generada", forbidden: "Estos leads están fuera de tu ámbito.",
  },
  report: {
    title: "Informe de activación", pdf: "Descargar PDF", reviewSend: "Revisar y enviar",
    reviewSendHint: "Los informes nunca se envían automáticamente. Verifique las cifras antes de enviarlo al socio.",
    confirmSend: "Enviar al socio", messageOptional: "Mensaje de acompañamiento (opcional)",
    sent: "Informe enviado", ambassadors: "Embajadores movilizados", leads: "Leads generados",
    missions: "Misiones completadas", content: "Contenidos / pruebas", summary: "Resumen de resultados",
    leadsDelivery: "Transmisión a VytaliLeads",
    lastSend: "Último envío a {{email}} el {{date}}",
    forbidden: "Este informe está fuera de su alcance.",
    loadError: "No se pudo cargar el informe.",
    quotaExceeded: "Cuota diaria de envío de Resend alcanzada. Inténtelo mañana o amplíe su límite en Resend. El PDF sigue disponible.",
    lastAttemptFailed: "Último intento de envío a {{email}} el {{date}} — no entregado",
  },
  retention: {
    title: "Conservación de fotos",
    lead: "Las fotos de prueba se eliminan automáticamente después de {{days}} días.",
    stored: "Almacenadas", expired: "Vencidas", purgedTotal: "Depuradas", days: "días",
    purgeNow: "Depurar ahora", purged: "{{n}} foto(s) eliminada(s)",
    purgeErrors: "No se pudieron depurar {{n}} foto(s) — consulte los registros",
    dailyJob: "Una depuración automática se ejecuta cada día. Los metadatos de misión y auditoría siempre se conservan.",
  },
  analytics: {
    title: "Analítica", lead: "Rendimiento por evento, equipo, Embajador y socio.",
    all: "Todos", reset: "Restablecer", export: "Exportar CSV", events: "Eventos",
    rsvps: "Inscripciones", attendanceRate: "Tasa de asistencia", noShowRate: "Tasa de ausencia",
    approvedProofs: "Pruebas aprobadas",
    activeAmbassadors: "Embajadores activos", uniqueAmbassadors: "Embajadores únicos",
    trend: "Asistencia por mes", topAmbassadors: "Mejores Embajadores", viewHistory: "Historial",
    participationHistory: "Historial de participación",
    event: "Evento", recordedAt: "Registrado",
    by: { events: "Evento", ambassadors: "Embajador", teams: "Equipo",
          partners: "Socio", campaigns: "Campaña" },
  },
  system: {
    activeSupers: "Súper administradores activos", roleAudit: "Registro de roles",
    activity: "Registro de actividad", nominate: "Nombrar un súper administrador",
    nominateLead: "Elija un administrador de confianza para no perder nunca el acceso.",
    grant: "Promover", revoke: "Degradar", supers: "Súper administradores",
    leadStatus: { new: "Nuevo", contacted: "Contactado", qualified: "Cualificado", closed: "Cerrado" },
  },
  account: {
    changeTitle: "Elija su contraseña", changeLead: "Para proteger su cuenta, defina su propia contraseña antes de continuar.",
    currentPassword: "Contraseña actual", newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña", savePassword: "Guardar contraseña",
    changed: "Contraseña actualizada", tooShort: "8 caracteres mínimo",
    mismatch: "Las contraseñas no coinciden",
    forgotTitle: "¿Olvidó su contraseña?", forgotLead: "Le enviaremos un enlace seguro de restablecimiento.",
    sendResetLink: "Enviar el enlace", resetSent: "Si existe una cuenta para esta dirección, se envió un correo.",
    resetTitle: "Nueva contraseña", resetInvalid: "Enlace no válido o vencido",
  },
  home: {
    hello: "Hola", nextEvent: "Su próximo VytaliDay", noEvent: "Ningún VytaliDay próximo",
    noEventHint: "Le avisaremos en cuanto se planifique una activación.",
    checkInNow: "Registrar mi llegada", myMissions: "Mis misiones", progress: "Mi progreso",
    attended: "Asistencias", missions: "Misiones aprobadas", score: "Puntaje", pending: "Pendiente",
    viewEvent: "Ver el evento", seeAll: "Ver todo",
  },
  events: {
    upcoming: "Próximos", past: "Pasados", detail: "Detalle del evento", agenda: "Programa",
    objectives: "Objetivos", partner: "Socio", campaign: "Campaña", location: "Lugar",
    capacity: "Capacidad", missions: "Misiones", participants: "Participantes",
    rsvp: "Confirmar mi asistencia", cancelRsvp: "Cancelar mi asistencia", waitlisted: "Lista de espera",
    rsvpConfirmed: "Asistencia confirmada", full: "Completo", shortCode: "Código corto",
    consentRequired: "Se requiere consentimiento antes de confirmar", noEvents: "Ningún evento",
    eventUnavailable: "Este evento no está disponible para ti en este momento.",
    confirmedCount: "confirmados", checkedIn: "presentes",
  },
  status: {
    confirmed: "Confirmado", waitlisted: "Lista de espera", cancelled: "Cancelado",
    no_show: "Ausencia", pending: "Pendiente", approved: "Aprobado", rejected: "Rechazado",
    draft: "Borrador", published: "Publicado", checked_in: "Presente", new: "Nuevo",
  },
  checkin: {
    title: "Registro", scan: "Escanear el código QR", enterCode: "Ingresar el código corto",
    code: "Código del evento", validate: "Validar", success: "¡Asistencia registrada!",
    already: "Ya está registrado", offlineQueued: "Sin conexión — guardado, sincronización pendiente",
    pendingSync: "registro pendiente de sincronización", syncNow: "Sincronizar",
    pendingSyncNotice: "Check-in pendiente de sincronización: podrás enviar la prueba en cuanto vuelva la red.",
    stateConfirmed: "Asistencia confirmada", statePendingSync: "Check-in pendiente de sincronización",
    stateNone: "Sin check-in",
    scannerMock: "¿Cámara no disponible? Use el código corto.",
  },
  missions: {
    submitProof: "Enviar una prueba", photo: "Foto", note: "Nota", completion: "Marcar como completado",
    reminder: "Recordatorio: solo contenido relacionado con el evento. Evite personas identificables sin su consentimiento.",
    takePhoto: "Elegir una foto", noteLabel: "Su nota", submitted: "Prueba enviada — pendiente de revisión",
    resubmit: "Enviar de nuevo", myProof: "Mi prueba", proofRemoved: "Foto eliminada por un administrador",
    objective: "Objetivo", instructions: "Instrucciones", proofExpected: "Prueba solicitada",
    deadline: "Fecha límite", required: "Obligatoria", optionalMission: "Opcional",
    viewDetail: "Ver el detalle", openAndSubmit: "Ver el detalle y enviar",
    checkinFirst: "Haz tu check-in en el lugar para poder enviar tu prueba.",
    expected_photo: "Una foto tomada durante el evento.",
    expected_note: "Una nota escrita que describa lo que lograste.",
    expected_completion: "Una simple confirmación de que la misión está completada.",
  },
  progress: {
    title: "Mi progreso", completed: "{{done}} / {{total}} misiones completadas",
    pointsEarned: "Puntos ganados", missionPoints: "{{n}} pts misiones", attendancePoints: "{{n}} pts asistencia",
    potential: "Pendientes", potentialHint: "No cuentan hasta la aprobación", todo: "Por hacer",
  },
  field: {
    title: "Modo Terreno", subtitle: "Todo lo que necesitas durante la activación.",
    doCheckin: "Hacer mi check-in", captureLead: "Capturar un lead",
    showQr: "Mostrar mi QR", addManual: "Añadir manualmente",
    myMissions: "Mis misiones", offlineMode: "Modo sin conexión",
    pendingActions: "Acciones pendientes de sincronización",
    pendingCheckins: "{{n}} check-in(s) pendientes", pendingLeads: "{{n}} lead(s) pendientes",
    synced: "Sincronización completada", noEvent: "Ninguna activación en curso.",
    noEventHint: "Haz tu check-in o elige un evento desde Mi QR.",
    chooseEvent: "Elige tu activación de hoy:",
    syncBlocked: "{{n}} lead(s) no se pudieron transmitir",
    stuckLeads: "Un lead espera un evento — abre Mi QR para completarlo.",
  },
  daySummary: {
    title: "Resumen de fin de jornada", leaders: "Jefe(s) de equipo",
    live: "Activación en curso — las cifras siguen cambiando.",
    cancelled: "Este evento está cancelado.",
    attendance: "Asistencia", registered: "Inscritos", present: "Presentes", noShow: "Ausentes",
    rate: "Tasa de asistencia", missions: "Misiones", missionsTotal: "Misiones previstas",
    pendingReview: "Pendientes de revisión", completion: "Tasa de finalización",
    completionHint: "Aprobadas / esperadas", leads: "Leads",
    points: "Puntos otorgados", pointsTotal: "Total", pointsManual: "Ajustes manuales",
    partnerReport: "Informe del socio", participants: "Participantes",
    reviewQueue: "Cola de revisión", generated: "Generado el",
    notCounted: "no contadas", notConfirmed: "no confirmados",
  },
  review: {
    queue: "Cola de revisión", needsReview: "Por revisar", approve: "Aprobar", reject: "Rechazar",
    rejectReason: "Motivo del rechazo", empty: "Nada por revisar — todo está al día",
    attendance: "Asistencias", markPresent: "Marcar presente", markNoShow: "Marcar ausente",
    removePhoto: "Eliminar la foto", reviewed: "Revisado",
  },
  admin: {
    invite: "Invitar", inviteUser: "Invitar a un usuario", role: "Rol", name: "Nombre",
    team: "Equipo", newEvent: "Nuevo evento", newCampaign: "Nueva campaña",
    newTeam: "Nuevo equipo", newPartner: "Nuevo socio", newMission: "Nueva misión",
    attendancePoints: "Puntos por asistencia", missionPoints: "Puntos por misión",
    retention: "Conservación de imágenes (días)", adjustScore: "Ajustar el puntaje",
    inviteCreated: "Invitación creada", inviteLink: "Enlace de invitación",
    super_admin: "Súper administrador", admin: "Administrador",
    team_leader: "Líder de equipo", ambassador: "Embajador",
    globalConfig: "Configuración de puntos", manualAdjust: "Ajuste manual",
    socialImage: "Imagen social — URL 1200 × 630",
  },
  profile: {
    title: "Perfil", myScore: "Mi puntaje", history: "Historial",
    prefsEmail: "Recibir correos", ledger: "Registro de puntos", noShows: "Ausencias",
  },
  notif: { title: "Notificaciones", empty: "Ninguna notificación", markAll: "Marcar todo como leído" },

  pub: {
    nav: { home: "Inicio", events: "Eventos", partners: "Socios", about: "Acerca de", login: "Iniciar sesión" },
    eyebrow: "Personas • Socios • Comunidad • Crecimiento",
    heroTitle: "Activaciones que generan movimiento.",
    heroText: "VytaliDays reúne a Embajadores, socios, comercios y comunidades a través de experiencias presenciales diseñadas para generar visibilidad, participación, nuevas relaciones y oportunidades de crecimiento.",
    ctaEvents: "Ver próximos VytaliDays",
    ctaPartner: "Convertirse en socio",
    ctaPartnerVytali: "Convertirse en socio Vytali",
    strategic: "VytaliDays transforma los eventos presenciales en oportunidades de crecimiento para las personas, los comercios y las comunidades.",
    whatTitle: "Más que un evento.",
    whatLead: "VytaliDays crea valor antes, durante y después de cada activación.",
    pillars: {
      ambassadors: { title: "Embajadores", text: "Personas movilizadas para crear interacciones, representar campañas y dar vida a la experiencia sobre el terreno." },
      partners: { title: "Socios", text: "Comercios y empresarios que se benefician de visibilidad, activaciones, contenido y nuevas oportunidades." },
      community: { title: "Comunidad", text: "Participantes y miembros que descubren nuevas personas, comercios y experiencias dentro del ecosistema Vytali." },
      growth: { title: "Crecimiento", text: "Cada activación puede contribuir a generar nuevos miembros, leads, relaciones comerciales, contenido y fidelización." },
    },
    phasesTitle: "Una activación que comienza antes del evento.",
    phases: {
      before: { label: "Antes", items: ["promoción del comercio socio", "contenido y publicaciones", "invitaciones", "movilización de Embajadores", "preparación de la campaña", "visibilidad previa al evento"] },
      during: { label: "Durante", items: ["presencia de Embajadores", "interacción con participantes", "activación del socio", "creación de contenido", "generación de leads", "registros", "experiencia comunitaria"] },
      after: { label: "Después", items: ["seguimiento de oportunidades", "conversión comercial", "contenido posterior al evento", "análisis de resultados", "desarrollo de la relación con el socio", "preparación de futuras activaciones"] },
    },
    upcomingTitle: "Próximos VytaliDays",
    upcomingLead: "Descubra las activaciones que llegan a su zona.",
    viewEvent: "Ver evento",
    noEvents: "Nuevos VytaliDays llegarán pronto.",
    allEvents: "Todos los VytaliDays",
    pastEvents: "Activaciones pasadas",
    partnerTitle: "Pon tu negocio en el centro de un próximo VytaliDay.",
    partnerText: "VytaliDays permite a comercios y empresarios socios beneficiarse de una activación completa alrededor de su negocio: visibilidad previa, presencia sobre el terreno, contenido, interacciones, generación de oportunidades y seguimiento posterior.",
    partnerBenefits: ["Visibilidad local", "Promoción previa al evento", "Activación por Embajadores", "Contenido de foto y video", "Generación de leads", "Exposición a la comunidad Vytali", "Participación de la clientela", "Medición de resultados"],
    retention: "Una alianza. Múltiples activaciones. Visibilidad continua.",
    businessTypes: { restaurant: "Restaurante", cafe: "Café", retail: "Comercio minorista", gym: "Gimnasio / deporte", beauty: "Belleza / bienestar", services: "Servicios", other: "Otro" },
    formTitle: "Hablemos de su próxima activación",
    formLead: "Complete este formulario y el equipo Vytali le contactará.",
    form: {
      firstName: "Nombre", lastName: "Apellido", business: "Nombre del negocio",
      email: "Correo electrónico", phone: "Teléfono", city: "Ciudad",
      businessType: "Tipo de negocio", language: "Idioma preferido", message: "Mensaje",
      goal: "¿Qué le gustaría desarrollar o mejorar?",
      consent: "Acepto ser contactado por Vytali en relación con mi solicitud.",
      send: "Enviar mi solicitud",
      success: "¡Gracias! Su solicitud fue recibida. El equipo Vytali le contactará pronto.",
      error: "El envío falló. Vuelva a intentarlo.",
      requiredField: "Este campo es obligatorio",
      invalidEmail: "Correo electrónico no válido",
      consentRequired: "Se requiere su consentimiento",
    },
    ambassadorTitle: "Los Embajadores dan vida a VytaliDays.",
    ambassadorText: "Los Embajadores son la capa humana de cada activación: crean las interacciones, representan las campañas y convierten un evento en una experiencia.",
    ambassadorPoints: ["Experiencia sobre el terreno", "Misiones concretas", "Desarrollo personal", "Formación", "Networking", "Progresión", "Generación de oportunidades", "Participación comunitaria"],
    ambassadorCta: "Acceso Embajador",
    ambassadorNote: "El acceso de Embajador es por invitación.",
    communityTitle: "Una comunidad que crece con cada evento.",
    communityText: "Cada VytaliDay crea nuevos encuentros y conexiones. Con el tiempo, estas interacciones ayudan a desarrollar una comunidad Vytali formada por miembros, Embajadores, socios y empresarios que pueden generar valor entre sí.",
    communityTags: ["Miembros", "Participantes", "Embajadores", "Comercios socios", "Empleados socios", "Empresarios"],
    activationTitle: "Interacciones que se convierten en oportunidades.",
    activationText: "Cada activación genera interacciones, registros, oportunidades cualificadas, referencias y compromiso del socio.",
    flixTitle: "Cada socio tiene una historia de crecimiento.",
    flixLine: "VytaliFlix captura la visión. VytaliDays pone la visión en movimiento.",
    flixText: "VytaliFlix puede documentar dónde está un socio hoy, qué quiere cambiar el empresario, qué espera lograr en los próximos seis meses y cuáles son sus expectativas. VytaliDays se convierte luego en uno de los momentos de activación concretos que pone esa visión en movimiento. Con el tiempo, Vytali puede documentar la evolución del socio.",
    flixCta: "Descubrir VytaliFlix",
    flixSoon: "VytaliFlix — disponible pronto",
    finalTitle: "¿Listo para formar parte del próximo movimiento?",
    aboutTitle: "Acerca de VytaliDays",
    aboutLead: "VytaliDays es la plataforma de activación presencial de Vytali: experiencias reales que reúnen a personas, comercios y comunidades.",
    aboutHow: "Cómo funciona",
    aboutSteps: [
      { title: "Una campaña", text: "Vytali define una campaña de activación con sus objetivos y su comercio socio." },
      { title: "Un VytaliDay", text: "Se planifica un evento presencial: lugar, horario, programa, misiones y Embajadores asignados." },
      { title: "La activación", text: "Los Embajadores crean interacciones, contenido y oportunidades en el lugar." },
      { title: "El seguimiento", text: "Los resultados se miden y alimentan la relación con el socio y las próximas activaciones." },
    ],
    footerTagline: "Una experiencia Vytali",
    footerPrivacy: "Privacidad", footerTerms: "Términos", footerContact: "Contacto",
    shareOn: "Compartir en",
  },
};

export default es;
